const { data } = require("jquery");

window.getFinalCurrentPosition = function() {
  new_width = $(document).find('body').width();
  screen_ratio = (new_width - $(document).find('.current-container').width())/2;
  margin_sum = (new_width * 0.2) * Math.max(($(document).find('.current-container').prevAll().length), 0) ;
  previous_sum = widthSum($(document).find('.current-container').prevAll());
  return (0-(margin_sum+previous_sum))+screen_ratio;
}

window.goToCurrent = function(){
  modal_content = $(document).find('.modal-content');
  if(modal_content) {
    modal_content.css("transform", `translateX(${getFinalCurrentPosition()}px)`);
  }
}

window.hideArrows = function (){
  current_video = $(document).find('.current-container');
  if(current_video.prevAll().length == 0) {
    $(document).find('.left-arrow').hide();
  } else {
    $(document).find('.left-arrow').show();
  }
  if(current_video.nextAll().length == 0) {
    $(document).find('.right-arrow').hide();
  } else {
    $(document).find('.right-arrow').show();
  }
}

window.bindPlayPauseEvents = function() {
  $('.videogfull').on('ended',function(){
    $(this).get(0).currentTime = 0
    $(this).parent().find('.play').show();
    $(this).parent().find('.pause').hide();
  });
  $('.videogfull').on('play',function(){
    $(this).parent().find('.play').hide();
    $(this).parent().find('.pause').show();
  });
  $('.videogfull').on('pause',function(){
    $(this).parent().find('.play').show();
    $(this).parent().find('.pause').hide();
  });
}


window.updateReactionsCount = function(videoId) {
  url = '/v2/reactions/reactions_count'
  body = {
    video_id: videoId
  }
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
    data: body,
    success: (data) => {
      console.log(data);
      $(document).find(`#like-count-${videoId}`).text(data["like"]);
      $(document).find(`#sticker-count-${videoId}`).text(data["sticker"]);
      $(document).find(`#comments-count-${videoId}`).text(data["comment"]);
    }
  });
}

window.closeReactionContents = function(element) {
  modal = $(element).parent().parent().parent().parent()
  modal.find('.content').css('display', 'none');
  modal.css('display', 'none');
}

window.updateQueryStringParameter = function(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

var notificationTimer;
window.showNotification = function(type) {
  text = ''
  if(type == 'comment') {
    text = 'Your <b>comment</b> reaction was successfully sent.'
  }
  if(type == 'sticker') {
    text = 'Your <b>sticker</b> reaction was successfully sent.'
  }
  $('.notification-container.alert-success').find('span').html(text);
  $('.notification-container.alert-success').css('display', 'flex');
  $('.notification-container.alert-success')[0].classList.add('animate__animated', 'animate__bounceIn');
  clearTimeout(notificationTimer);
  notificationTimer = 0;
  notificationTimer = setTimeout(function() {
    $('.notification-container.alert-success').css('display', 'none');
    $('.notification-container.alert-success')[0].classList.remove('animate__animated', 'animate__bounceIn');
  }, 3000)
}

$.fn.dataArray = function( name ) {
  return this.map( function( i, element ) {
      return $(element).data( name );
  });
};

window.widthSum = function(elements) {
  var totalWidth = 0;
  elements.each(function(index) {
    totalWidth += $(this).width();
  });
  return totalWidth;
}

$(document).on('turbolinks:load', function() {
  $(document).on('click', '.video-grid .videog', function(e) {
    modal = document.getElementById("video-modal");
    url = $(this).attr('data-url');
    $(document).find('#modal-trigger-video').attr("href", url);
    $(document).find('#modal-trigger-video')[0].click();
    $('body').addClass('stop-scrolling');
    modal.style.display = "flex";
  });

  $(document).on('click', '.close-trigger-1', function(e) {
    modal = document.getElementById("video-modal");
    video = $(document).find('.current-container').find('video').get(0);
    if(video){
      video.pause();
      video.removeAttribute('src');
      video.innerHTML = '';
      video.load();
      video.remove();
    }
    $(document).find('.current-container').parent().parent().empty();
    $('body').removeClass('stop-scrolling');
    modal.style.display = "none";
  });

  $(document).on('click', '.close-trigger-2', function(e) {
    modal = document.getElementById("video-modal");
    video = $(document).find('.current-container').find('video').get(0);
    if(video){
      video.pause();
    }
    modal.style.display = "none";
  });

  $(window).on('resize', function(e) {
    goToCurrent();
  });

  var loading_right = false;
  $(document).on('click', '.right-arrow', function(e) {
    if(loading_right) return false;
    loading_right = true;
    goToCurrent();
    width = $(document).find('body').width();
    current = $(document).find('.current-container');
    next = current.next();
    modal_content = current.parent();
    var end = (current.nextAll().length - 1) == 0
    if(end) {
      Rails.ajax({
        type: 'GET',
        url: `/v2/video_center/${next.attr("data-video-id")}/show_next_videos.json?page=${next.attr("data-video-page")}&filter=${next.attr("data-filter")}&search=${next.attr("data-search")}`,
        dataType: 'json',
        success: (data) => {
          next.parent().append(data.entries);
          bindPlayPauseEvents();
          hideArrows();
        }
      })
    }

    value = modal_content.css("transform").split(",")[4].trim()
    margin_width = width * 0.2;
    size_inc = next.width() + margin_width;

    $({y:value}).animate({y:value-size_inc}, {
      duration: 500,
      step: function(val) {
        modal_content.css("transform", `translateX(${val}px)`);
      },
      done: function(){
        current.find('video').get(0).pause();
        current.removeClass('current-container');
        current.addClass('prev-video');
        next.addClass('current-container');
        next.removeClass('next-video');
        next.find('video').get(0).play();
        hideArrows();
        loading_right = false;
      }
    })
  });

  var loading_left = false
  $(document).on('click', '.left-arrow', function(e) {
    if(loading_left) return false;
    loading_left = true;
    goToCurrent();
    width = $(document).find('body').width();
    current = $(document).find('.current-container');
    prev = current.prev();
    modal_content = current.parent();

    var begining = (current.prevAll().length - 1) == 0

    value = parseFloat(modal_content.css("transform").split(",")[4].trim());
    margin_width = width * 0.2;
    size_inc = prev.width() + margin_width;
    new_value = value + size_inc;

    $({y:value}).animate({y:new_value}, {
      duration: 500,
      step: function(val) {
        modal_content.css("transform", `translateX(${val}px)`);
      },
      done: function(){
        if(begining) {
          Rails.ajax({
            type: 'GET',
            url: `/v2/video_center/${prev.attr("data-video-id")}/show_prev_videos.json?page=${prev.attr("data-video-page")}&filter=${prev.attr("data-filter")}&search=${prev.attr("data-search")}`,
            dataType: 'json',
            success: (data) => {
              prev.parent().prepend(data.entries);
              goToCurrent();
              hideArrows();
              bindPlayPauseEvents();
              loading_left = false;
            }
          })
        }
        current.find('video').get(0).pause();
        current.removeClass('current-container');
        current.addClass('next-video');
        prev.addClass('current-container');
        prev.removeClass('prev-video');
        prev.find('video').get(0).play();
        if(!begining) {
          hideArrows();
          loading_left = false;
        }
      }
    })
  });

  $(document).on('click', '.modal', function(event) {
    modal = document.getElementById("video-modal");
    video = $(document).find('.current-container').find('video').get(0);
    if (event.target == modal) {
      modal = document.getElementById("video-modal");
      video.pause();
      video.remove();
      $('body').removeClass('stop-scrolling');
      modal.style.display = "none";
    }
  });

  $(document).on('click', '.expand-more', function(e) {
    $(this).parent().find('.donation-detail-container').css('display', 'flex');
    $(this).parent().find('.expand-less').css('display', 'flex');
    $(this).parent().find('.expand-more').hide();
  });

  $(document).on('click', '.expand-less', function(e) {
    $(this).parent().find('.donation-detail-container').hide();
    $(this).parent().find('.expand-less').hide();
    $(this).parent().find('.expand-more').css('display', 'flex');
  });

  $(document).on('click', '.filter', function(e) {
    filter_params = $(this).attr('data-filter');
    url = window.location.href
    new_url = updateQueryStringParameter(url, 'filter', filter_params)
    page_one_url = updateQueryStringParameter(new_url, 'page', '1')
    window.location.href = page_one_url;
  });

  $(document).on('click', '.search-button', function(e) {
    search_params = $(this).parent().find('input').val();
    url = window.location.href
    new_url = updateQueryStringParameter(url, 'search', search_params)
    page_one_url = updateQueryStringParameter(new_url, 'page', '1')
    window.location.href = page_one_url;
  });

  $(document).on('keypress', '.search-input', function(e) {
    if (e.key === "Enter") {
      search_params = $(this).val();
      url = window.location.href
      new_url = updateQueryStringParameter(url, 'search', search_params)
      page_one_url = updateQueryStringParameter(new_url, 'page', '1')
      window.location.href = page_one_url;
    }
  });

  // Video controls events
  var timer;

  // play and pause button
  $(document).on('click', '.play-trigger', function(e) {
    video = $(this).parent().parent().find('video').get(0);
    if(video.paused) {
      video.play();
      $(this).parent().find('.play').hide();
      $(this).parent().find('.pause').show();
    } else {
      video.pause();
      $(this).parent().find('.play').show();
      $(this).parent().find('.pause').hide();
    }
    clearTimeout(timer);
    timer = 0;
    // Mostrar controls e ocultar depois de 2 segundos (criar funcao)
    controls = $(this).parent().find('.video-controls');
    controls.css('display', 'flex');
    clearTimeout(timer);
    timer = 0;
    timer = setTimeout(function() {
        controls = $(document).find('.current-container').find('.video-controls');
        video = $(document).find('.current-container').find('video').get(0);
        if(!video.paused) {
          controls.css('display', 'none');
          $('.videogfull').css({
            cursor: 'none'
          });
          fadeInBuffer = true;
        }
    }, 2000)
  });

  // backward button
  $(document).on('click', '.backward', function(e) {
    video = $(this).parent().parent().find('video').get(0);
    video.currentTime = video.currentTime - 10
    clearTimeout(timer);
    timer = 0;
    // Mostrar controls e ocultar depois de 2 segundos (criar funcao)
    controls = $(this).parent().find('.video-controls');
    controls.css('display', 'flex');
    clearTimeout(timer);
    timer = 0;
    timer = setTimeout(function() {
        controls = $(document).find('.current-container').find('.video-controls');
        video = $(document).find('.current-container').find('video').get(0);
        if(!video.paused) {
          controls.css('display', 'none');
          $('.videogfull').css({
            cursor: 'none'
          });
          fadeInBuffer = true;
        }
    }, 2000)
  });

  // backward button
  $(document).on('click', '.forward', function(e) {
    video = $(this).parent().parent().find('video').get(0);
    video.currentTime = video.currentTime + 10
    clearTimeout(timer);
    timer = 0;
    // Mostrar controls e ocultar depois de 2 segundos (criar funcao)
    controls = $(this).parent().find('.video-controls');
    controls.css('display', 'flex');
    clearTimeout(timer);
    timer = 0;
    timer = setTimeout(function() {
        controls = $(document).find('.current-container').find('.video-controls');
        video = $(document).find('.current-container').find('video').get(0);
        if(!video.paused) {
          controls.css('display', 'none');
          $('.videogfull').css({
            cursor: 'none'
          });
          fadeInBuffer = true;
        }
    }, 2000)
  });

  // current video clicks (play or pause video and show controls)
  $(document).on('click', '.current-container .videogfull', function(e) {
    //video = $(this).get(0);
    // if(video.paused) {
    //   video.play();
    //   $(this).parent().find('.play').hide();
    //   $(this).parent().find('.pause').show();
    // } else {
    //   video.pause();
    //   $(this).parent().find('.play').show();
    //   $(this).parent().find('.pause').hide();
    // }
    // Mostrar controls e ocultar depois de 2 segundos (criar funcao)
    $('.videog').css({
      cursor: 'pointer'
    });
    controls = $(this).parent().find('.video-controls');
    if(controls.css('display') == 'flex') {
      controls.css('display', 'none');
    } else {
      controls.css('display', 'flex');
    }
    clearTimeout(timer);
    timer = 0;
    timer = setTimeout(function() {
        controls = $(document).find('.current-container').find('.video-controls');
        video = $(document).find('.current-container').find('video').get(0);
        if(!video.paused) {
          controls.css('display', 'none');
          $('.videog').css({
            cursor: 'none'
          });
          fadeInBuffer = true;
        }
    }, 2000)
  });

  // mouse move on video will show controls
  $(document).on('mousemove', '.current-container .videogfull', function(e) {
    $('.videogfull').css({
      cursor: 'pointer'
    });

    clearTimeout(timer);
    timer = 0;
    // Mostrar controls e ocultar depois de 2 segundos (criar funcao)
    //controls = $(this).parent().find('.video-controls');
    //controls.css('display', 'flex');
    clearTimeout(timer);
    timer = 0;
    timer = setTimeout(function() {
      controls = $(document).find('.current-container').find('.video-controls');
      video = $(document).find('.current-container').find('video').get(0);
      if(!video.paused) {
        controls.css('display', 'none');
        $('.videogfull').css({
          cursor: 'none'
        });
        fadeInBuffer = true;
      }
    }, 2000)
  });

  // // mouse out from video will hide controls (only if the video is playing)
  // $(document).on('mouseout', '.current-container .videog', function(e) {
  //   $('.videog').css({
  //     cursor: 'pointer'
  //   });
  //   controls = $(document).find('.current-container').find('.video-controls');
  //   video = $(document).find('.current-container').find('video').get(0);
  //   if(!video.paused) {
  //     controls.css('display', 'none');
  //   }
  //   clearTimeout(timer);
  //   timer = 0;
  // });

  // // Mouse over video controls will display videos controls
  // $(document).on('mouseover', '.current-container .video-controls', function(e) {
  //   $('.videog').css({
  //     cursor: 'pointer'
  //   });
  //   controls = $(document).find('.current-container').find('.video-controls');
  //   controls.css('display', 'flex');
  //   clearTimeout(timer);
  //   timer = 0;
  // });

  $(document).on('mouseover', '.video-grid .videog', function(e) {
    this.play();
  });

  $(document).on('mouseout', '.video-grid .videog', function(e) {
    this.pause();
  });

  $(document).find('.videog').on('canplay', function (event) {
    $(this).removeClass('background');
  });

  $(document).on('click', '.comments-trigger svg', function(e) {
    modal = $(this).parent().parent().parent().find('.reaction-modal');
    comments = modal.find('.comments-content');
    modal.css('display', 'flex');
    comments.css('display', 'flex');
  });

  $(document).on('click', '.sticker-trigger svg', function(e) {
    modal = $(this).parent().parent().parent().find('.reaction-modal');
    stickers = modal.find('.stickers-content');
    modal.css('display', 'flex');
    stickers.css('display', 'flex');
  });

  $(document).on('click', '.close-reaction-modal-trigger', function(e) {
    closeReactionContents(this);
  });

  $(document).on('click', '.reaction-item', function(e) {
    current = $(this)
    selected = current.parent().find('.selected');
    if(current.hasClass('selected')) {
      current.removeClass('selected');
      return null;
    }
    if (selected.length >= 3) return null;

    current.addClass('selected');
  });

  $(document).on('click', '.done-reaction-modal-trigger', function(e) {
    url = '/v2/reactions'
    list = $(this).parent().parent().find('.reaction-list');
    selected = list.find('.selected');
    data_array = selected.dataArray('info');
    type = list.data('type');
    videoId = list.data('video-id');
    body = {
      reaction_type: type,
      info: { content_id: data_array.toArray() },
      video_id: videoId
    }
    if(data_array.length > 0) {
      $.ajax({
        type: 'POST',
        url: url,
        dataType: 'json',
        data: body,
        success: (data) => {
          closeReactionContents(this);
          selected.removeClass('selected');
          updateReactionsCount(videoId);
          showNotification(type);
        }
      });
    }
  });

  $(document).on('click', '.like-trigger svg', function(e) {
    url = '/v2/reactions/create_like'
    video = $(this).parent().parent().parent();
    videoId = video.data('video-id');
    body = {
      reaction_type: 'like',
      video_id: videoId
    }
    $(this)[0].classList.add('animate__animated', 'animate__rubberBand');
    $.ajax({
      type: 'POST',
      url: url,
      dataType: 'json',
      data: body,
      success: (data) => {
        updateReactionsCount(videoId);
      }
    });
  });
});
